import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import qs from 'qs';
import ApplicationAppService from '../platform/application-app-service';

const applicationData = ApplicationAppService.getApplicationData();

const publicAxios = axios.create({
  baseURL: applicationData.baseUrl,
  paramsSerializer: {
    serialize: (params: any) => qs.stringify(params, { indices: false }),
  },
});

const executeRequest = async (config: AxiosRequestConfig) => {
  try {
    const result = await publicAxios.request(config);
    return { data: result?.data || null };
  } catch (error) {
    let errorMessage = 'Erro ao processar requisição';
    let errorDetails = '';

    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<any>;

      if (axiosError.response) {
        const responseData = axiosError.response.data;

        errorMessage =
          responseData?.message ||
          responseData?.error ||
          responseData?.title ||
          axiosError.response.statusText ||
          `Erro HTTP ${axiosError.response.status}`;

        if (responseData && typeof responseData === 'object') {
          try {
            errorDetails = JSON.stringify(responseData, null, 2);
          } catch {
            errorDetails = String(responseData);
          }
        }
      } else if (axiosError.request) {
        errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
        errorDetails = JSON.stringify({
          error: 'No response from server',
          url: axiosError.config?.url,
          method: axiosError.config?.method?.toUpperCase()
        }, null, 2);
      } else {
        errorMessage = axiosError.message || 'Erro ao configurar requisição';
        errorDetails = JSON.stringify({
          error: 'Request configuration error',
          message: axiosError.message
        }, null, 2);
      }
    } else {
      errorMessage = (error as Error)?.message || 'Erro desconhecido';
      try {
        errorDetails = JSON.stringify({
          error: 'Non-axios error',
          message: errorMessage,
          type: (error as Error)?.constructor?.name || 'Unknown'
        }, null, 2);
      } catch {
        errorDetails = errorMessage;
      }
    }

    const customError = new Error(errorMessage);
    (customError as any).details = errorDetails;
    (customError as any).originalError = error;

    throw customError;
  }
};

const PublicHttpClient = {
  executeRequest
};

export default PublicHttpClient;
